import * as React from "react";

const DefaultFlowIcon = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="#7B838C" fillRule="nonzero">
      <path d="M25 36h6.199v6.248H25zM25 29h6.199v6.246H25zM25 22h6.199v6.248H25zM32 22h6.199v6.248H32zM32 29h6.199v6.248H32zM39 29h6.199v6.248H39zM18 29h6.2v6.246H18zM24.2 22h-4.358C18.825 22 18 22.8 18 23.786v4.462h6.2V22zM39 22h4.358c1.017 0 1.842.8 1.842 1.786v4.462H39V22zM24.2 36H18v4.459c0 .988.825 1.789 1.842 1.789H24.2V36zM39 36v6.248h4.36c1.015 0 1.84-.801 1.84-1.789V36H39zM32 36h6.2v6.248H32z" />
    </g>
  </svg>
);

export default DefaultFlowIcon;

